var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationLine = function SvgLocationLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24292D",
    d: "M11.54 12.95a.5.5 0 1 1 0 1H4.542a.5.5 0 1 1 0-1zM8.041 2c3.106 0 5.048 3.363 3.465 6.1l-3.063 4.16a.5.5 0 0 1-.805 0L4.545 8.054C2.993 5.363 4.935 2 8.041 2zm0 1c-2.338 0-3.798 2.53-2.66 4.508l2.66 3.612 2.63-3.566C11.838 5.53 10.378 3 8.041 3zm0 1.562a1.585 1.585 0 1 1-.001 3.17 1.585 1.585 0 0 1 0-3.17zm0 1a.585.585 0 1 0 0 1.17.585.585 0 0 0 0-1.17z"
  })));
};
export default SvgLocationLine;